import { z } from 'zod';

export const eventStatusSchema = z.enum(['draft', 'published']);

export type EventStatus = z.infer<typeof eventStatusSchema>;

// Бэкенд отдаёт file_name/official_title вместо name; name оставлен для старых версий API
const eventDocumentSchema = z
  .object({
    id: z.string(),
    name: z.string().nullable().optional(),
    file_name: z.string().nullable().optional(),
    official_title: z.string().nullable().optional(),
  })
  .transform((raw) => ({
    id: raw.id,
    name: raw.name?.trim() || raw.official_title?.trim() || raw.file_name?.trim() || '',
  }));

export const eventSchema = z
  .object({
    id: z.number().int(),
    title: z.string(),
    description: z.string().nullable().optional(),
    agenda_text: z.string().nullable().optional(),
    start_at: z.string(),
    status: eventStatusSchema,
    folder_path: z.array(z.string()).nullable().optional(),
    documents: z.array(eventDocumentSchema).nullable().optional(),
    organization_id: z.number().int().optional(),
    action: z.string().nullable().optional(),
  })
  .transform((raw) => ({
    documents: raw.documents ?? [],
    id: raw.id,
    title: raw.title,
    description: raw.description ?? '',
    agendaText: raw.agenda_text ?? null,
    startAt: raw.start_at,
    status: raw.status,
    folderPath: raw.folder_path ?? [],
    organizationId: raw.organization_id ?? null,
    action: raw.action ?? null,
  }));

export type EventEntityApi = z.input<typeof eventSchema>;
export type EventEntity = z.infer<typeof eventSchema>;

export const eventsOrganizationListResponseSchema = z.object({
  items: z.array(eventSchema),
  total: z.number(),
});

export type EventsOrganizationListResponseApi = z.input<typeof eventsOrganizationListResponseSchema>;
export type EventsOrganizationListResponse = z.infer<typeof eventsOrganizationListResponseSchema>;
